<template>
  <div>
    <div class="statistics-header">
      <a-button
        type="primary"
        size="small"
        @click="isFilterDrawerVisible = true"
      >
        {{ $tm('statistic.filter.selectDepartment') }}
      </a-button>
      <div class="cycle-container">
        <Cycle />
      </div>
    </div>
    <DepartmentTagList
      :selected-departments="selectedDepartments"
      @delete="onUnselectDepartment"
    />
    <DepartmentsChart :department-ids="departmentIds" />
    <FilterDrawer
      ref="filterDrawerRef"
      v-model:is-visible="isFilterDrawerVisible"
      v-model:department-map="departmentMap"
      @filter="onFilter"
    />
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'

import Cycle from '@/components/Cycle'
import FilterDrawer from './FilterDrawer'
import DepartmentTagList from '@/components/DepartmentTagList'
import DepartmentsChart from './DepartmentsChart'

export default defineComponent({
  name: 'DepartmentStatistic',
  components: {
    Cycle,
    FilterDrawer,
    DepartmentTagList,
    DepartmentsChart
  },
  setup () {
    const filterDrawerRef = ref()
    const isFilterDrawerVisible = ref(false)
    const departmentIds = ref([])
    const departmentMap = ref({})
    const selectedDepartments = computed(() =>
      departmentIds.value.map(id => ({
        id,
        name: departmentMap.value[id]
      }))
    )

    function onFilter (checkedDepartmentIds) {
      departmentIds.value = checkedDepartmentIds
    }

    function onUnselectDepartment (unselecteId) {
      filterDrawerRef.value.uncheckKey(unselecteId)
      departmentIds.value = departmentIds.value.filter(id => id !== unselecteId)
    }

    return {
      filterDrawerRef,
      isFilterDrawerVisible,
      departmentIds,
      departmentMap,
      selectedDepartments,
      onFilter,
      onUnselectDepartment
    }
  }
})
</script>
